<template>
  <div class="stack">
    <img class="stack-loading-spinner" :src="require('@/assets/icons/spinner.svg')" />
  </div>
</template>

<script>
export default {
  name: 'progressGraphic',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.stack {
  position: absolute;
  z-index: 100;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  background: white;

  display: flex;
  justify-content: center;
  align-items: center;

  .stack-loading-spinner {
    height: 75px;
    width: 75px;
  }
}
</style>
